/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Inbound_Field_Purchase_OrderInputs */

const en_inbound_field_purchase_order = /** @type {(inputs: Inbound_Field_Purchase_OrderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Purchase order`)
};

/**
* | output |
* | --- |
* | "Purchase order" |
*
* @param {Inbound_Field_Purchase_OrderInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const inbound_field_purchase_order = /** @type {((inputs?: Inbound_Field_Purchase_OrderInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Inbound_Field_Purchase_OrderInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_inbound_field_purchase_order(inputs)
});